// 솟다 모의투자 — 종목 유니버스 (시총순 + 섹터/테마 메타)
// symbol = Yahoo 심볼 그대로 (체결/평가 route가 그대로 사용)
// design doc §18-J: 섹터/테마 메타 도입 + 미국/코인 확장.
//   ⚠ 환각 방지 룰: 한국 종목코드(6자리.KS)는 추측 박제 위험(과거 KRX ISU_CD 환각 사고) →
//     검증 확신분만 정적 추가. 수백 확장은 KRX 종목마스터 동적 소스로(보고 후, §18-J).
//   미국 티커·코인 심볼은 표준이라 환각 위험 낮음 → 대형주 확장.

export type SimSymbol = {
  asset_class: 'stock' | 'crypto';
  symbol: string;
  name: string;
  market: 'kr' | 'us' | 'crypto';
  sector?: string;     // 섹터(반도체·금융·바이오 등 — 큐 K 섹터 탐색)
  themes?: string[];   // 테마 태그(AI·2차전지 등 — 큐 K 테마 묶음)
  // ETF 표식. 체결·시세 경로는 주식과 완전히 같아서 asset_class는 'stock'을 그대로 쓴다
  // (서버 trade route가 'stock'|'crypto'만 분기). 화면 배지·설명 문구용 메타.
  kind?: 'etf';
};

export const SIM_SYMBOLS: SimSymbol[] = [
  // ── 한국 대형주 (종목코드 검증 확신분만) ──
  { asset_class: 'stock', symbol: '005930.KS', name: '삼성전자', market: 'kr', sector: '반도체', themes: ['반도체', 'AI'] },
  { asset_class: 'stock', symbol: '000660.KS', name: 'SK하이닉스', market: 'kr', sector: '반도체', themes: ['반도체', 'AI'] },
  { asset_class: 'stock', symbol: '373220.KS', name: 'LG에너지솔루션', market: 'kr', sector: '2차전지', themes: ['2차전지', '전기차'] },
  { asset_class: 'stock', symbol: '207940.KS', name: '삼성바이오로직스', market: 'kr', sector: '바이오·헬스', themes: ['바이오'] },
  { asset_class: 'stock', symbol: '005380.KS', name: '현대차', market: 'kr', sector: '자동차', themes: ['전기차'] },
  { asset_class: 'stock', symbol: '000270.KS', name: '기아', market: 'kr', sector: '자동차', themes: ['전기차'] },
  { asset_class: 'stock', symbol: '035420.KS', name: 'NAVER', market: 'kr', sector: 'IT·인터넷', themes: ['빅테크', 'AI'] },
  { asset_class: 'stock', symbol: '035720.KS', name: '카카오', market: 'kr', sector: 'IT·인터넷', themes: ['빅테크'] },
  { asset_class: 'stock', symbol: '005935.KS', name: '삼성전자우', market: 'kr', sector: '반도체', themes: ['반도체'] }, // WebSearch 검증(우선주)
  // ── 한국 확장 12종 (2026-06-13 — seedTickers.js 검증 풀 + 전 종목 prod quote 스모크 통과) ──
  { asset_class: 'stock', symbol: '042700.KS', name: '한미반도체', market: 'kr', sector: '반도체', themes: ['반도체', 'AI'] },
  { asset_class: 'stock', symbol: '068270.KS', name: '셀트리온', market: 'kr', sector: '바이오·헬스', themes: ['바이오'] },
  { asset_class: 'stock', symbol: '005490.KS', name: 'POSCO홀딩스', market: 'kr', sector: '산업재', themes: ['2차전지'] },
  { asset_class: 'stock', symbol: '051910.KS', name: 'LG화학', market: 'kr', sector: '2차전지', themes: ['2차전지'] },
  { asset_class: 'stock', symbol: '003670.KS', name: '포스코퓨처엠', market: 'kr', sector: '2차전지', themes: ['2차전지'] },
  { asset_class: 'stock', symbol: '012330.KS', name: '현대모비스', market: 'kr', sector: '자동차', themes: ['전기차'] },
  { asset_class: 'stock', symbol: '105560.KS', name: 'KB금융', market: 'kr', sector: '금융', themes: [] },
  { asset_class: 'stock', symbol: '055550.KS', name: '신한지주', market: 'kr', sector: '금융', themes: [] },
  { asset_class: 'stock', symbol: '028260.KS', name: '삼성물산', market: 'kr', sector: '산업재', themes: [] },
  { asset_class: 'stock', symbol: '017670.KS', name: 'SK텔레콤', market: 'kr', sector: '통신·미디어', themes: ['AI'] },
  { asset_class: 'stock', symbol: '047810.KS', name: '한국항공우주', market: 'kr', sector: '산업재', themes: ['우주'] },
  { asset_class: 'stock', symbol: '196170.KQ', name: '알테오젠', market: 'kr', sector: '바이오·헬스', themes: ['바이오'] }, // KOSDAQ=.KQ

  // ── 미국 빅테크 (기존) ──
  { asset_class: 'stock', symbol: 'NVDA', name: '엔비디아', market: 'us', sector: '반도체', themes: ['반도체', 'AI', '빅테크'] },
  { asset_class: 'stock', symbol: 'AAPL', name: '애플', market: 'us', sector: 'IT·인터넷', themes: ['빅테크'] },
  { asset_class: 'stock', symbol: 'MSFT', name: '마이크로소프트', market: 'us', sector: 'IT·인터넷', themes: ['빅테크', 'AI', '클라우드'] },
  { asset_class: 'stock', symbol: 'GOOGL', name: '알파벳', market: 'us', sector: '통신·미디어', themes: ['빅테크', 'AI'] },
  { asset_class: 'stock', symbol: 'AMZN', name: '아마존', market: 'us', sector: '소비재', themes: ['빅테크', '클라우드'] },
  { asset_class: 'stock', symbol: 'TSLA', name: '테슬라', market: 'us', sector: '자동차', themes: ['전기차', '빅테크'] },
  { asset_class: 'stock', symbol: 'META', name: '메타', market: 'us', sector: '통신·미디어', themes: ['빅테크', 'AI'] },
  // SPCX: 2026-06-12 나스닥 상장(공모가 $135 · WebSearch+prod quote 검증 2026-06-13)
  { asset_class: 'stock', symbol: 'SPCX', name: '스페이스X', market: 'us', sector: '산업재', themes: ['우주'] },

  // ── 미국 반도체·기술 확장 ──
  { asset_class: 'stock', symbol: 'AVGO', name: '브로드컴', market: 'us', sector: '반도체', themes: ['반도체', 'AI'] },
  { asset_class: 'stock', symbol: 'AMD', name: 'AMD', market: 'us', sector: '반도체', themes: ['반도체', 'AI'] },
  { asset_class: 'stock', symbol: 'INTC', name: '인텔', market: 'us', sector: '반도체', themes: ['반도체'] },
  { asset_class: 'stock', symbol: 'QCOM', name: '퀄컴', market: 'us', sector: '반도체', themes: ['반도체'] },
  { asset_class: 'stock', symbol: 'TXN', name: '텍사스인스트루먼츠', market: 'us', sector: '반도체', themes: ['반도체'] },
  { asset_class: 'stock', symbol: 'ORCL', name: '오라클', market: 'us', sector: 'IT·인터넷', themes: ['클라우드', 'AI'] },
  { asset_class: 'stock', symbol: 'CRM', name: '세일즈포스', market: 'us', sector: 'IT·인터넷', themes: ['클라우드'] },
  { asset_class: 'stock', symbol: 'ADBE', name: '어도비', market: 'us', sector: 'IT·인터넷', themes: ['클라우드'] },
  { asset_class: 'stock', symbol: 'CSCO', name: '시스코', market: 'us', sector: 'IT·인터넷', themes: ['클라우드'] },

  // ── 미국 금융 ──
  { asset_class: 'stock', symbol: 'JPM', name: 'JP모건', market: 'us', sector: '금융', themes: ['핀테크'] },
  { asset_class: 'stock', symbol: 'V', name: '비자', market: 'us', sector: '금융', themes: ['핀테크'] },
  { asset_class: 'stock', symbol: 'MA', name: '마스터카드', market: 'us', sector: '금융', themes: ['핀테크'] },
  { asset_class: 'stock', symbol: 'BAC', name: '뱅크오브아메리카', market: 'us', sector: '금융', themes: [] },
  { asset_class: 'stock', symbol: 'BRK-B', name: '버크셔해서웨이', market: 'us', sector: '금융', themes: [] },

  // ── 미국 소비재 ──
  { asset_class: 'stock', symbol: 'WMT', name: '월마트', market: 'us', sector: '소비재', themes: [] },
  { asset_class: 'stock', symbol: 'COST', name: '코스트코', market: 'us', sector: '소비재', themes: [] },
  { asset_class: 'stock', symbol: 'HD', name: '홈디포', market: 'us', sector: '소비재', themes: [] },
  { asset_class: 'stock', symbol: 'MCD', name: '맥도날드', market: 'us', sector: '소비재', themes: [] },
  { asset_class: 'stock', symbol: 'NKE', name: '나이키', market: 'us', sector: '소비재', themes: [] },
  { asset_class: 'stock', symbol: 'KO', name: '코카콜라', market: 'us', sector: '소비재', themes: [] },
  { asset_class: 'stock', symbol: 'PEP', name: '펩시코', market: 'us', sector: '소비재', themes: [] },
  { asset_class: 'stock', symbol: 'PG', name: '프록터앤드갬블', market: 'us', sector: '소비재', themes: [] },

  // ── 미국 헬스케어 ──
  { asset_class: 'stock', symbol: 'UNH', name: '유나이티드헬스', market: 'us', sector: '바이오·헬스', themes: [] },
  { asset_class: 'stock', symbol: 'JNJ', name: '존슨앤드존슨', market: 'us', sector: '바이오·헬스', themes: ['바이오'] },
  { asset_class: 'stock', symbol: 'LLY', name: '일라이릴리', market: 'us', sector: '바이오·헬스', themes: ['바이오'] },
  { asset_class: 'stock', symbol: 'PFE', name: '화이자', market: 'us', sector: '바이오·헬스', themes: ['바이오'] },
  { asset_class: 'stock', symbol: 'MRK', name: '머크', market: 'us', sector: '바이오·헬스', themes: ['바이오'] },

  // ── 미국 통신·미디어·에너지·산업 ──
  { asset_class: 'stock', symbol: 'NFLX', name: '넷플릭스', market: 'us', sector: '통신·미디어', themes: ['빅테크'] },
  { asset_class: 'stock', symbol: 'DIS', name: '디즈니', market: 'us', sector: '통신·미디어', themes: [] },
  { asset_class: 'stock', symbol: 'XOM', name: '엑슨모빌', market: 'us', sector: '에너지', themes: [] },
  { asset_class: 'stock', symbol: 'CVX', name: '셰브론', market: 'us', sector: '에너지', themes: [] },
  { asset_class: 'stock', symbol: 'BA', name: '보잉', market: 'us', sector: '산업재', themes: [] },
  { asset_class: 'stock', symbol: 'CAT', name: '캐터필러', market: 'us', sector: '산업재', themes: [] },

  // ── ETF (2026-07-26 편입) ──
  // 배경: 체결 route에는 심볼 화이트리스트가 없어 ETF는 이미 매수 가능했는데, 로컬 유니버스에만
  //   없어서 비교·알림·발굴·이름조회 화면이 전부 못 따라왔다(QQQ를 보유해도 이름 대신 티커 노출).
  // ⚠ 심볼·정식명은 프로덕션 `/api/market/search` 실호출로 검증(2026-07-26) — 추측 박제 아님.
  // ⚠ 레버리지·인버스(TQQQ·SQQQ·SOXL 등)는 목록에 넣지 않는다. 검색으로는 도달 가능하고,
  //   그쪽엔 경고 배지(leveragedEtf.js)가 붙는다. 발굴·추천 목록에 3배 상품을 올리지 않기 위함.
  { asset_class: 'stock', symbol: 'QQQ', name: '인베스코 QQQ(나스닥100)', market: 'us', sector: 'ETF·지수', themes: ['ETF'], kind: 'etf' },
  { asset_class: 'stock', symbol: 'SPY', name: 'SPDR S&P500', market: 'us', sector: 'ETF·지수', themes: ['ETF'], kind: 'etf' },
  { asset_class: 'stock', symbol: 'VOO', name: '뱅가드 S&P500', market: 'us', sector: 'ETF·지수', themes: ['ETF'], kind: 'etf' },
  { asset_class: 'stock', symbol: 'SCHD', name: '슈왑 미국 배당주', market: 'us', sector: 'ETF·지수', themes: ['ETF'], kind: 'etf' },
  { asset_class: 'stock', symbol: 'SOXX', name: '아이셰어즈 반도체', market: 'us', sector: 'ETF·지수', themes: ['ETF', '반도체'], kind: 'etf' },
  { asset_class: 'stock', symbol: '069500.KS', name: 'KODEX 200', market: 'kr', sector: 'ETF·지수', themes: ['ETF'], kind: 'etf' },

  // ── 코인 ──
  { asset_class: 'crypto', symbol: 'BTC-USD', name: '비트코인', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'ETH-USD', name: '이더리움', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'SOL-USD', name: '솔라나', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'XRP-USD', name: '리플', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'BNB-USD', name: '바이낸스코인', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'DOGE-USD', name: '도지코인', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'ADA-USD', name: '카르다노', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'AVAX-USD', name: '아발란체', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'LINK-USD', name: '체인링크', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'DOT-USD', name: '폴카닷', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'TRX-USD', name: '트론', market: 'crypto', sector: '코인', themes: ['코인'] },
  { asset_class: 'crypto', symbol: 'LTC-USD', name: '라이트코인', market: 'crypto', sector: '코인', themes: ['코인'] },
];

export const MARKET_LABEL: Record<string, string> = {
  kr: '🇰🇷 한국',
  us: '🇺🇸 미국',
  crypto: '코인',
  etc: '🌐 해외', // 서버 검색(/api/market/search) 결과 중 미국 외 거래소
};

// 섹터 목록 (큐 K 섹터 탐색 — 실제 종목에 매핑된 순서)
export const SECTORS = [
  '반도체', 'IT·인터넷', '자동차', '2차전지', '바이오·헬스',
  '금융', '소비재', '에너지', '통신·미디어', '산업재', 'ETF·지수', '코인',
] as const;

// 테마 목록 (큐 K 테마 묶음 — 종목 themes 태그와 매칭)
export const THEMES = [
  'AI', '반도체', '2차전지', '전기차', '빅테크', '클라우드', '바이오', '핀테크', '우주', 'ETF', '코인',
] as const;

/** 섹터별 종목 */
export function symbolsBySector(sector: string): SimSymbol[] {
  return SIM_SYMBOLS.filter((s) => s.sector === sector);
}
/** 테마별 종목(themes 태그 포함) */
export function symbolsByTheme(theme: string): SimSymbol[] {
  return SIM_SYMBOLS.filter((s) => (s.themes || []).includes(theme));
}
